export default __webpack_public_path__ + "static/media/arrow_bottom1.e1b3b4bb.svg";